@if(showScrollTop) {
<button
  class="scroll-to-top"
  type="button"
  (click)="scrollToTop()"
  aria-label="Scroll to top"
>
  <span class="icon-wrapper">
    <i class="bi bi-mouse"></i>
    <i class="bi bi-mouse-fill"></i>
  </span>
  <span>SCROLL TO TOP</span>
</button>
}
